"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VenueItem;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VenueItem(_ref) {
  var venue = _ref.venue,
      openModal = _ref.openModal,
      destroy = _ref.destroy;

  return _react2.default.createElement(
    "div",
    { className: "row-fluid result" },
    _react2.default.createElement(
      "a",
      { className: "col-md-11", onClick: openModal },
      _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col-md-1 result-img" },
          venue.thumbnail_url && _react2.default.createElement("img", { src: venue.thumbnail_url, width: "72", height: "72", alt: "" })
        ),
        _react2.default.createElement(
          "div",
          { className: "col-md-6 result-info" },
          _react2.default.createElement(
            "h3",
            null,
            venue.name
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "col-md-5 result-meta" },
          _react2.default.createElement(
            "p",
            null,
            venue.city
          )
        )
      )
    ),
    _react2.default.createElement("a", {
      className: "col-md-1 result-delete",
      href: "#",
      onClick: destroy.bind(this, venue.id)
    })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Venue/VenueItem.js
// module id = 2254
// module chunks = 0